import * as React from 'react';

declare const rootUrl: string;

interface VitaloJak2PositionStepsProps {
    onNext: () => void;
    onBack: () => void;
}

export const VitaloJak2PositionSteps = ({ onNext, onBack }: VitaloJak2PositionStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Position Microphone and Sensor</h2>
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>On the chest sensor peel back the larger portion of the protective covering</li>
                            <li>Prepare the area then adhere the chest sensor to the subject so that the sticky pad touches the bottom of the suprasternal notch and the sensor wire hangs down. The suprasternal notch is a large, visible dip located between the neck and the collarbone</li>
                            <li>Remove the remaining protective covering from the sensor sticky pad</li>
                            <li>Clip the microphone to the outside of the subject's clothing, between 4 and 6 inches (10cm and 15cm) away from the subject's mouth</li>
                            <li>On the device select 'Start Recording'</li>
                            <li>Confirm the subject and visit details</li>
                            <li>Confirm the date and time are accurate</li>
                            <li>Confirm the recording duration</li>
                            <li>Wait for the recording to start and confirm the screen is blank and the indicator light on the front of the device is flashing green</li>
                            <li>Seal the device into the pouch and secure tightly with a zip tie then fasten it around subject’s waist and provide guidance to subject for recording period</li>
                        </ol>
                    </div>
                    <div className="col-md-12 text-center">
                        <img style={{ width: '100%', maxWidth: '500px' }} src={rootUrl + '/Images/Wizards/vitalojak2-4.png'} alt="" />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
}
